@if (showVerifyEmail()) {
    <div class="verify-page">
        <div class="verify-card">
            <div class="verify-icon">
                <svg width="32" height="32" viewBox="0 0 24 24">
                    <use href="assets/icons/icons-sprite.svg#mail"></use>
                </svg>
            </div>

            <h3 class="verify-title">Check your email</h3>

            <div class="verify-details">
                <p class="verify-body">
                    We sent a verification link to
                    @if (userEmail()) {
                        <strong>{{ userEmail() }}</strong
                        >.
                    } @else {
                        your email address.
                    }
                </p>
                <p class="verify-hint">
                    Please verify your account, A link has been sent to your registered email.
                </p>
            </div>

            <div class="verify-timer">
                @if (!timerExpired()) {
                    <span class="verify-timer__label">Time remaining</span>
                    <span class="verify-timer__value">
                        {{ timerDisplay() }}
                    </span>
                } @else {
                    <p class="verify-resend__hint">
                        The verification link expired. Please request a new link.
                    </p>
                }
            </div>

            <ntv-button
                size="lg"
                variant="accent"
                [disabled]="timerActive()"
                (click)="resendEmail()">
                Resend Email
            </ntv-button>
        </div>
    </div>
} @else {
    <div class="callback-page">
        <div class="callback-spinner" role="status" aria-label="Authenticating">
            <span class="spinner-ring"></span>
            <span class="spinner-ring"></span>
            <span class="spinner-ring"></span>
        </div>
        <p class="callback-caption">{{ caption }}</p>
    </div>
}
